import state from './objectsState'
import actions from './objectsActions'
import getters from './objectsGetters'
import mutations from './objectsMutations'

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
